import React from "react";

import {
  ImageFragment,
  OpenGraphMetaTagsFragment,
  PageBuilderSectionsFragment,
  PageBuilderOpeningHeroFragment
} from "types/graphql-types";
import { createClient } from "picosanity";

import {
  isSanityImagePresent,
  sanityImageUrl
} from "@silversea-ssc/ui-components-react";
import sanityImageUrlBuilder from "@sanity/image-url";
import { ImageUrlBuilder } from "@sanity/image-url/lib/types/builder";
//import ConfigMedium from "@silversea-ssc/design-system-tokens/dist/fonts/config/Config-Medium.woff2";

import { isPresent } from "src/utils/checks";
import sanityLocation from "src/utils/sanityLocation";
import { buildGetRequest } from "src/ssc-api/useFetchApi";

export const fallbackOpenGraphFromPageBuilderSections = (
  sections: (PageBuilderSectionsFragment | undefined)[] | undefined
): { fallbackSeoTitle?: string; fallbackSeoImage?: string } => {
  const filteredSections = sections?.filter(isPresent) || [];
  const fallbackSeo = filteredSections.find(
    (i) => i.__typename == "SanityOpeningHero"
  ) as PageBuilderOpeningHeroFragment | null;

  const fallbackSeoTitle = fallbackSeo?.title?.localized;
  const fallbackSeoImage = fallbackSeo?.background?.asset?.url;
  return { fallbackSeoTitle, fallbackSeoImage };
};

const buildOpenGraphImageUrl = (
  builder: ImageUrlBuilder,
  image: ImageFragment | undefined
): string | undefined => {
  if (isSanityImagePresent(image))
    return sanityImageUrl(builder, image.asset, { width: 1200, height: 630 });

  return undefined;
};

export const buildSEOImageUrl = (
  image: OpenGraphMetaTagsFragment["image"]
): string | undefined => {
  const sanityClient = createClient({
    ...sanityLocation,
    useCdn: true
  });
  const builder = sanityImageUrlBuilder(sanityClient);
  return buildOpenGraphImageUrl(builder, image);
};

export const prefetchMetaForPromoApi = () => {
  const request = buildGetRequest<unknown>(`promos`);

  return (
    <link
      key="prefetch-promo-api"
      rel="prefetch"
      href={request}
      as="fetch"
      type="application/json"
    />
  );
};
